<template>
  <div class="job-shift-date">
    <p class="job-shift-date__label">{{ $t(`jobDetail['${type}Date']`) }}</p>
    <p class="job-shift-date__date">{{ date }}</p>
  </div>
</template>

<script>
export default {
  props: {
    date: {
      required: true,
      type: String,
    },
    type: {
      default: 'start',
      type: String,
    },
  },
}
</script>

<style lang="postcss" scoped>
.job-shift-date {
  @apply flex items-center;
}
.job-shift-date__label {
  @apply flex-grow;
}
.job-shift-date__date {
  @apply w-shift-item ml-2;
}

@screen desktop {
  .job-shift-date__date {
    @apply w-shift-item-desktop;
  }
}
</style>
